<template>
    <main class="layout-about">
        <transition appear name="fade">
            <div class="zone-nav">
                <BackButton @click="back"/>
            </div>
        </transition>

        <div class="zone-info">
            <transition appear name="fade">
                <section class="mt-1 delay-1000">
                    <h3>{{ $t("wv_home_04") }}</h3>
                    <p class="test">{{ $t("wv_home_05") }}</p>
                </section>
            </transition>

            <transition appear name="fade">
                <section class="mt-1 delay-1400">
                    <h3>{{ $t("wv_home_06") }}</h3>
                    <p>{{ $t("wv_home_07") }}</p>
                </section>
            </transition>


            <transition appear name="fade">
                <section class="delay-1800">
                    <hr class="my-2 bar" aria-hidden="true" />
                    <div class="nasaCredit">
                        <NasaLogo class="nasaLogo"/>
                        <p class="nasaStatement small">{{ $t("wv_home_08") }}</p>
                    </div>
                </section>
            </transition>
        </div>
    </main>
</template>


<script>
import NasaLogo from '@/assets/svg/nasa-logo.svg'
import BackButton from "@/components/common/BackButton"

export default {
    name: 'Home',
    components: {
        NasaLogo,
        BackButton
    },
    head: {
        title: {
            inner: 'About',
            separator: '|',
            complement: 'GMRI.org LabVenture'
        },
        meta: function() {
            return [
                {name: 'description', content: this.description},

                {property: 'og:title', content: 'About | Gulf of Maine Research Institute, LabVenture'},
                {property: 'og:description', content: this.description},
                {property: 'og:type', content: 'website'},
                {property: 'og:locale', content: 'en_us'},
                {property: 'og:image', content: `${window.location.origin}/img/previews/00_homepage.jpg`},

                {rel: 'canonical', href: window.location.href}
            ]
        }
    },
    methods:{
        back(){
            this.$router.push({name: 'home'})
        },
    },
    async mounted() {
        await this.$store.dispatch("global/setNavState", 'intro')
        this.$announcer.set(this.$t("wv_home_04"));
    }
}
</script>


<style scoped lang="scss">
@import "@/assets/styles/_vars.scss";

.layout-about{

    p{
        font-size: calc(min(1rem, 16px)) !important;
        line-height:  calc(min(1.4rem, 24px)) !important;
    }
    .small{
        font-size: calc(min(.8rem, 14px)) !important;
        line-height:  calc(min(1rem, 20px)) !important;
    }

    .paragraph{
        margin-right: $s2;
        max-width: 550px;

    }


    .nasaCredit{
        display: flex;
        
        .nasaLogo{
            margin-right: 20px;
        }
        .nasaStatement{
            width: 85%;
            margin-top: 0px;
        }
    }
}

</style>
